/** Filter backend default notify IDs to project users that have an email address. */
export const getDefaultNotifyUserIdsWithEmail = (users, defaultUserIds) => {
  if (!Array.isArray(users) || !Array.isArray(defaultUserIds)) {
    return [];
  }

  const defaultIdSet = new Set(defaultUserIds.map((id) => String(id)));
  return users
    .filter((user) => {
      const userId = String(user.id || user._id);
      return defaultIdSet.has(userId) && user.email;
    })
    .map((user) => String(user.id || user._id));
};
